/* ──────────────────────────────────────────────────────────────
   src/layouts/DashboardLayout.tsx
   Drawer lateral (colapsable) + TopBar con campana y menú cuenta
   ────────────────────────────────────────────────────────────── */
import { useState } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import NotificationBell from '../components/NotificationBell';
import AccountMenu from '../components/AccountMenu';
import LanguageSwitch from '../components/LanguageSwitch';

export default function DashboardLayout() {
  const [open, setOpen] = useState(true); // sidebar abierto/cerrado
  const { t } = useTranslation<'translation'>();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* =========== TOP BAR =========== */}
      <TopBar
        title={t<string>('dashboard.title')}
        onToggleSidebar={() => setOpen(!open)}
        rightSlot={
          <>
            <Box
              sx={{
                mr: 1,
                '& .MuiSvgIcon-root': { color: '#fff !important' },
                '& .MuiInputBase-root': { color: '#fff !important' },
              }}
            >
              <NotificationBell />
              <LanguageSwitch />
              <AccountMenu />
            </Box>
          </>
        }
      />

      {/* =========== SIDEBAR =========== */}
      <Box component="nav" sx={{ width: open ? 240 : 56, flexShrink: 0 }}>
        <Sidebar collapsed={!open} />
      </Box>

      {/* =========== CONTENIDO =========== */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: '48px', // alto del TopBar (dense)
        }}
      >
        {/* Aquí React-Router inyecta la ruta hija */}
        <Outlet />
      </Box>
    </Box>
  );
}
